module.exports = __webpack_public_path__ + "static/media/facebook-fb-social-icon-svgrepo-com.f34eddf4.svg";